module.exports = __webpack_public_path__ + "img/Savings-rafiki.6e8405bb.png";